const NotFound = () => {
  window.location.href = '/404'
}

export default NotFound
